import { Element, useNode } from "@craftjs/core";
import * as React from "react";
import { Actions } from "src/types";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import Button from "@/components/editor/primitives/button/button-component";
import RichText from "@/components/editor/primitives/rich-text";

import {
  DEFAULT_PARAGRAPH_ITEM_CTATEXT,
  DEFAULT_PARAGRAPH_ITEM_DESCRIPTION,
  DEFAULT_PARAGRAPH_ITEM_SUBTITLE,
} from "./constants";
import { CTAButtonWrapper, Wrapper } from "./paragraph-item-component-styles";

export type ParagraphItemProps = {
  showCTA?: boolean;
};

export default function ParagraphItem(props: ParagraphItemProps) {
  const {
    connectors: { connect },
  } = useNode();

  return (
    <Wrapper ref={connect}>
      <Element
        id="paragraph-item-sub-title"
        is={RichText}
        text={`<h3>${DEFAULT_PARAGRAPH_ITEM_SUBTITLE}</h3>`}
      />
      <Element
        id="paragraph-item-description"
        is={RichText}
        text={`<p>${DEFAULT_PARAGRAPH_ITEM_DESCRIPTION}</p>`}
      />
      {props.showCTA && (
        <CTAButtonWrapper>
          <Element
            id="cta-button"
            is={Button}
            text={DEFAULT_PARAGRAPH_ITEM_CTATEXT}
            action={{
              kind: Actions.TicketSelector,
            }}
          />
        </CTAButtonWrapper>
      )}
    </Wrapper>
  );
}

ParagraphItem.craft = {
  custom: {
    displayName: "Paragraph Item",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
  },
};
